// Smooth scroll navigation and scroll to top button

import { isTouch } from './utils.js';

export const initSmoothScroll = () => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const HEADER = 84;
  const DURATION = 900;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function scrollToY(targetY) {
    const startY = window.scrollY || window.pageYOffset;
    const dist = targetY - startY;
    if (Math.abs(dist) < 2) return;

    let start = null;
    function step(ts) {
      if (start === null) start = ts;
      const elapsed = ts - start;
      const t = Math.min(elapsed / DURATION, 1);
      window.scrollTo(0, startY + dist * easeInOutCubic(t));
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // Anchor link smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    const id = a.getAttribute('href');
    if (!id || id === '#') return;

    a.addEventListener('click', e => {
      const target = document.querySelector(id);
      if (!target) return;

      e.preventDefault();
      const y =
        target.getBoundingClientRect().top +
        (window.scrollY || window.pageYOffset) -
        HEADER;

      // На мобилке - обычный скролл без smooth для лучшей производительности
      if (isTouch()) {
        window.scrollTo(0, y);
      } else if (reduce) {
        window.scrollTo(0, y);
      } else {
        scrollToY(y);
      }
      history.replaceState(null, '', id);
    });
  });
};

export const initScrollToTop = () => {
  const btn = document.getElementById('toTop');
  if (!btn) return;

  function upd() {
    if (window.scrollY > 600) {
      btn.classList.add('show');
    } else {
      btn.classList.remove('show');
    }
  }

  window.addEventListener('scroll', upd, { passive: true });
  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  upd();
};
